function n(n,t){return new Promise((function(e){setTimeout((function(){e(t)}),n)}))}export{n as delay};
